module.exports = __webpack_public_path__ + "static/media/0213_Small.00ef3858.jpg";